<template>
  <CustomModal ref="modal" title="Valider la signature">
    <div>
      <CustomForm ref="form" :inputs=undefined :submit=buttons.submit>
          <div class="waring" style="margin-top: 15px">
            <span>Attention : en validant la signature, vous vous engagez à conserver le devis signé de manière manuscrite par vos propres moyens.</span>
          </div>
        <CustomButton @click="submitForm" :params=buttons.submit style="margin-top: 15px" />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";

  export default {
      name: 'SignBusinessModal',
      props: ['callback'],
      components: {CustomModal, CustomForm, CustomButton},
      data() {
          return {
            business: undefined,
            buttons:{
              submit: {text: "J'ai compris et je valide"}
            }
          };
      },
      methods: {
        openModal(business) {
          this.$refs.modal.openModal();
          this.$refs.form?.startLoading();
          this.business = business;
          this.$refs.form?.stopLoading();
        },
        closeModal() {
          this.$refs.modal?.closeModal();
        },
        terminate(){
          this.closeModal();
          this.callback(true);
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => BusinessController.validateSignature(this.business.id));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Devis signé");
            this.terminate();
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';

    .separator
      margin-top 15px
      height 2px
      background-color THEME_COLOR_PRIMARY_FADDED
      opacity 0.6

    .state-container
      display flex
      flex-direction column
      margin-top 30px
      .waring
        border solid 2px #ffd78e
        background-color #fff6e6
        color #553900
        padding 10px
        margin-bottom 15px
      .separator-state-container
        width 30px
</style>
